import { createStyles } from "antd-style";

export const useProfileFormStyles = createStyles(({ css }: any) => ({
  root: css``,
  formFields: css``,
  formAvatar: css`
    height: 100%;
  `,
  formActions: css`
    button {
      min-width: 164px;
    }
  `,
}));
